import { forwardRef } from "react";

import { Input } from "shared/ui/shadcn/input";
import { clsxMerge } from "shared/lib/helpers";

// Need to create a factory function that returns a function because <ReactPhoneInput /> expects a component for the "inputComponent" prop.
// Returning a component from a function this way allows us to pass in custom props like the `inputClassName`.
export const createPhoneInputComponent = (inputClassName?: string) => {
  const InputComponent = forwardRef<
    HTMLInputElement,
    React.ComponentProps<"input">
  >((props, ref) => {
    return (
      <Input
        {...props}
        className={clsxMerge(inputClassName, props.className)}
        ref={ref}
      />
    );
  });

  InputComponent.displayName = "PhoneInputComponent";
  return InputComponent;
};
